/**
 * iVCEBlast Validation Schema
 */

import { z } from 'zod';
import { evaluateExpression } from '../shared';

export const schema = z.object({
  project: z.string().min(1, 'Project name is required'),
  title: z.string().min(1, 'Title is required'),

  mass: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Mass must be a valid expression greater than 0'),

  LHV: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'LHV must be a valid expression greater than 0'),

  mf: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0 && n <= 20;
  }, 'Mach number must be a valid expression greater than 0 and less than or equal to 20'),

  R: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n > 0;
  }, 'Distance must be a valid expression greater than 0'),

  Confinement: z.enum(['Confined', 'UnConfined']),

  V: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'Volume must be a valid expression greater than or equal to 0'),

  A: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'Surface area must be a valid expression greater than or equal to 0')
});

export type FormValues = z.infer<typeof schema>;
export type ParsedValues = z.output<typeof schema>;
